import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.map";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { getMinCreditScore, getMinCreditScoreDictionary, getMinCreditScoreTypesForTooltip } from '@nerdwallet/marketplace/selectors/mortgages';
import { MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS, MORTGAGES_LOAN_PRODUCT_LABELS as LEGACY_LOAN_PRODUCT_LABELS, MORTGAGES_LOAN_TYPE_LABELS as LEGACY_LOAN_TYPE_LABELS } from '@nerdwallet/marketplace/constants';
import { Type } from '@nerdwallet/currency';
/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/drivers/mortgages` directly.
 */

export { getDriverLoanTypesAndProducts as getQuickFactLoanTypesAndProducts, getDriverMaxLtv as getQuickFactMaxLtv, getDriverMinDownPayment as getQuickFactMinDownPayment, getDriverNationalRegional as getQuickFactNationalRegional } from '@nerdwallet/marketplace/drivers/mortgages';
/**
 * Label map that works for both the Lender Post & Marketplace data models.
 */

var MIN_CREDIT_SCORE_TOOLTIP_TYPES_AND_LABELS = _objectSpread(_objectSpread(_objectSpread({}, MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS), LEGACY_LOAN_PRODUCT_LABELS), LEGACY_LOAN_TYPE_LABELS);
/**
 * @todo - Create Structured Content compatible tooltip and backport into `@nerdwallet/marketplace/drivers/mortgages`.
 * @see {@link https://nerdwallet.atlassian.net/browse/RUR-171}
 */


export var getQuickFactMinCreditScore = function getQuickFactMinCreditScore(lender) {
  var _ref, _get2;

  var forcedType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var minCreditScoreObject = getMinCreditScoreDictionary(lender);
  var minCreditScore = (_ref = (_get2 = _get(minCreditScoreObject, forcedType)) !== null && _get2 !== void 0 ? _get2 :
  /**
   * Hack to coerce forced type to accomodate canonical enums
   */
  _get(minCreditScoreObject, forcedType === null || forcedType === void 0 ? void 0 : forcedType.toUpperCase())) !== null && _ref !== void 0 ? _ref : getMinCreditScore(lender);
  var creditScoreTypes = getMinCreditScoreTypesForTooltip(lender);
  var valueTooltip = creditScoreTypes && !_isEmpty(creditScoreTypes) ? creditScoreTypes.map(function (type) {
    var label = MIN_CREDIT_SCORE_TOOLTIP_TYPES_AND_LABELS[type];

    if (!label) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      key: type,
      className: classes(['display-flex', 'justify-content-space-between'])
    }, /*#__PURE__*/React.createElement(Type, {
      className: classes(['margin-right-1', 'nowrap']),
      light: true
    }, label, ":"), /*#__PURE__*/React.createElement(Type, {
      className: classes('nowrap'),
      color: "neutral-darkest"
    }, _get(minCreditScoreObject, type)));
  }) : null;
  return {
    id: 'minCreditScore',
    label: 'Min. Credit Score',
    value: minCreditScore,
    valueTooltip: valueTooltip
  };
};